export default __webpack_public_path__ + "static/media/OTPauthentication.38916d3d.svg";